// Where a staged file is in its life: picked but not sent, in flight, stored,
// or rejected by the server. `staged` is the only state a file can be removed
// from, and `error` the only one it can be retried from.
export const UPLOAD_STATUS = {
    STAGED   : "staged",
    UPLOADING: "uploading",
    DONE     : "done",
    ERROR    : "error"
};

// Which preview a staged file gets. An image is shown as itself; everything
// else falls back to a glyph, since the browser cannot thumbnail it without
// first putting it in a frame.
export const PREVIEW_KIND = {
    IMAGE: "image",
    PDF  : "pdf",
    FILE : "file"
};

export const DEFAULT_MAX_SIZE_MB = 10;

export const UPLOAD_FAILED_MESSAGE = "Upload failed. Please try again.";
